import { render, staticRenderFns } from "./EmployeeCoreData.vue?vue&type=template&id=18c78d02&scoped=true&"
import script from "./EmployeeCoreData.vue?vue&type=script&lang=js&"
export * from "./EmployeeCoreData.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCoreData.vue?vue&type=style&index=0&id=18c78d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c78d02",
  null
  
)

export default component.exports